export enum LANGUAGES {
  fr = "fr",
  en = "en",
  es = "es",
}
